import { render, staticRenderFns } from "./DialogOcopEdit.vue?vue&type=template&id=92fef0b8&scoped=true"
import script from "./DialogOcopEdit.vue?vue&type=script&lang=js"
export * from "./DialogOcopEdit.vue?vue&type=script&lang=js"
import style0 from "./DialogOcopEdit.vue?vue&type=style&index=0&id=92fef0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fef0b8",
  null
  
)

export default component.exports